var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu"},[_c('nav-all'),_vm._l((_vm.navList),function(v){return _c('nav-main',{key:v.id,attrs:{"menu":v}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }